// src/services/emailService.js
import axios from "axios";
import { buildHeaders } from "./_headers.util";

const EMAILS_API = `${process.env.VUE_APP_API_URL}emails`;
const LABELS_API = `${process.env.VUE_APP_API_URL}email-labels`;

class EmailService {
  // ---------------------------
  // Emails
  // ---------------------------
  listEmails(params = {}, companyId = null) {
    return axios.get(`${EMAILS_API}`, {
      params,
      headers: buildHeaders({}, companyId),
    });
  }

  getEmail(id, companyId = null) {
    return axios.get(`${EMAILS_API}/${id}`, {
      headers: buildHeaders({}, companyId),
    });
  }

  setRead(id, is_read, companyId = null) {
    return axios.patch(
      `${EMAILS_API}/${id}/read`,
      { is_read: !!is_read },
      { headers: buildHeaders({}, companyId) }
    );
  }

  moveEmail(id, folder, companyId = null) {
    return axios.patch(
      `${EMAILS_API}/${id}/move`,
      { folder },
      { headers: buildHeaders({}, companyId) }
    );
  }

  deleteEmail(id, companyId = null) {
    return axios.delete(`${EMAILS_API}/${id}`, {
      headers: buildHeaders({}, companyId),
    });
  }

  // Step 7: send / reply / drafts
  send(payload = {}, companyId = null) {
    return axios.post(`${EMAILS_API}/send`, payload, {
      headers: buildHeaders({}, companyId),
    });
  }

  reply(emailId, payload = {}, companyId = null) {
    return axios.post(`${EMAILS_API}/${emailId}/reply`, payload, {
      headers: buildHeaders({}, companyId),
    });
  }

  createDraft(payload = {}, companyId = null) {
    return axios.post(`${EMAILS_API}/drafts`, payload, {
      headers: buildHeaders({}, companyId),
    });
  }

  updateDraft(draftId, payload = {}, companyId = null) {
    return axios.put(`${EMAILS_API}/drafts/${draftId}`, payload, {
      headers: buildHeaders({}, companyId),
    });
  }

  sendDraft(draftId, payload = {}, companyId = null) {
    return axios.post(`${EMAILS_API}/drafts/${draftId}/send`, payload, {
      headers: buildHeaders({}, companyId),
    });
  }

  // ---------------------------
  // Attachments (Step 8)
  // ---------------------------
  uploadAttachments(formData, companyId = null) {
    return axios.post(`${EMAILS_API}/attachments/upload`, formData, {
      headers: {
        ...buildHeaders({}, companyId),
        "Content-Type": "multipart/form-data",
      },
    });
  }

  previewAttachment(id, companyId = null) {
    return axios.get(`${EMAILS_API}/attachments/${id}/preview`, {
      headers: buildHeaders({}, companyId),
    });
  }

  downloadAttachment(id, companyId = null) {
    return axios.get(`${EMAILS_API}/attachments/${id}/download`, {
      headers: buildHeaders({}, companyId),
      responseType: "blob",
    });
  }

  deleteAttachment(id, companyId = null) {
    return axios.delete(`${EMAILS_API}/attachments/${id}`, {
      headers: buildHeaders({}, companyId),
    });
  }

  // ---------------------------
  // Labels (Step 3/5)
  // ---------------------------
  getLabels(companyId = null) {
    return axios.get(`${LABELS_API}`, { headers: buildHeaders({}, companyId) });
  }

  createLabel(payload = {}, companyId = null) {
    return axios.post(`${LABELS_API}`, payload, {
      headers: buildHeaders({}, companyId),
    });
  }

  updateLabel(id, payload = {}, companyId = null) {
    return axios.put(`${LABELS_API}/${id}`, payload, {
      headers: buildHeaders({}, companyId),
    });
  }

  deleteLabel(id, companyId = null) {
    return axios.delete(`${LABELS_API}/${id}`, {
      headers: buildHeaders({}, companyId),
    });
  }
}

export default new EmailService();
